import { useToast } from "@kamae-apps/shared/old/Component/Toast/Context"
import { errorToast, successToast } from "@kamae-apps/shared/old/Component/Toast/ToastBuilder"
import { apiRequest } from "@kamae-apps/shared/utils"
import { useCallback, useState } from "react"
import { UserData } from "../User"

export const useSendMonthlyRecapModal = ({ userData }: { userData: UserData }) => {
  const [loading, setLoading] = useState(false)
  const toast = useToast()
  const [title, header, button] = [
    "Envoyer le récap mensuel",
    "Voulez vous vraiment envoyer le récap mensuel à l'utilisateur ?",
    "Envoyer",
  ]
  const sendMonthlyRecap = useCallback(() => {
    setLoading(true)
    const url = `/supervision/mail/month/recap/${userData.companyId}?user=${userData.id}`
    apiRequest(url, { method: "POST" })
      .then(() => {
        toast.addToast(successToast("Mail envoyé"))
        setLoading(false)
      })
      .catch(() => {
        toast.addToast(errorToast("Erreur lors de l'envoi"))
        setLoading(false)
      })
  }, [userData, toast])

  return {
    loading,
    setLoading,
    title,
    header,
    button,
    sendMonthlyRecap,
  }
}
